<template>
    <div id="app" :class="{'--app': $route.name == 'app'}">
        <v-app>
            <!-- Snackbar -->
            <snackbar />

            <!-- Confirm Dialog -->
            <confirm />

            <v-progress-linear
                v-show="showImportProgress"
                v-model="importProgress"
                :indeterminate="showImportProgress == 'indeterminate' ? true : false"
                id="import-image-progress"
                :color="'#bb86fc'"
                height="3"
            ></v-progress-linear>

            <v-navigation-drawer
                :value="isWhatsNewDrawerOpen"
                @input="toggleWhatsNewDrawer"
                floating
                temporary
                width="25%"
				style="z-index: 30 !important"
            >
                <WhatsNew />
            </v-navigation-drawer>

			<button id="fcs-btn" data-fsc-action="Add,Checkout" style="display: none">Purchase</button>
            <i class="material-symbols-outlined">temp_preferences_custom</i>

            <router-view />
        </v-app>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Snackbar from "@/components/Snackbar";
import Confirm from "@/components/Confirm";
import WhatsNew from "@/components/app/ui/whats-new.vue";

export default {
    components: {
        WhatsNew,
        Snackbar,
        Confirm,
    },

    computed: {
        ...mapState("Loader", ["importProgress", "showImportProgress"]),
        ...mapState("UI", ['isWhatsNewDrawerOpen']),
    },

    methods: {
        ...mapActions('UI', ['toggleWhatsNewDrawer']),
    }
};
</script>

<style lang="scss" scoped>
.material-symbols-outlined {
    position: absolute;
    z-index: -1;
    visibility: hidden;
    opacity: 0;
}
</style>

<style lang="scss">
body {
    padding: 0;
    margin: 0;
}

@media (max-width: 575px) {
    .v-application--wrap {
        overflow-y: scroll;
    }
}

.table {
    color: #eee !important;
}

* {
    box-sizing: border-box;
    line-height: 0.5;
    transition: all 0.2s ease;
}

a {
    text-decoration: none;
}

:root {
    font-size: 12px;

    --bg-sidebar-left: #121212;
    --bg-sidebar-right: #121212;
    --primary: #bb86fc !important;
	--dark-gray: rgb(33, 33, 33);
    --modal-bg: #1e1e1e;
    --font-default-color: #989898;
    --block-bg: #202020;
    --color-bg-dark: #121212;
    --color-bg-gray: #191919;
    --color-bg-gray-2: #2A2A2A;
    --color-accent: #bb86fc;
    --color-accent-2: #8d68f6;
    --color-group-separator: rgb(36, 36, 36);
	--color-light: #ffffff;
	--color-title-light: #ffffff;
	--color-tooltip-text: #c0c0c0;

    --item-active-highlight: #212143;

    --box-rounding: 15px;
    --thumbnail-lg-border-radius: 10px;
    --thumbnail-sm-border-radius: 5px;

    --color-warning: #d8a732;
    --color-danger: #d95040;

	--base-layout-top-height: 59px;
}

#app {
    font-family: Poppins, sans-serif !important;
    // -webkit-font-smoothing: antialiased;
    // -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    // color: #2c3e50;
    max-height: 100vh;
    height: 100vh;
    line-height: 1.2 !important;
}

.v-navigation-drawer {
    position: absolute;
    z-index: 30;
    height: calc(100vh - 150px) !important;
    top: calc(50% - (50vh - 75px)) !important;
    background-color: var(--color-bg-gray-2) !important;
    //box-shadow: rgba(100, 100, 111, 0.1) 0px 7px 29px 0px;
    border-radius: 0 var(--box-rounding) var(--box-rounding) 0;
}

#fsc-popup-frame {
    height: 100%;
}

form {
    // display: block;
    text-align: left;
    button[type="submit"] {
        margin-top: 25px;
        display: block;
        justify-self: center;
        margin-left: auto;
        margin-right: auto;
    }
}

.v-btn {
    font-weight: 600 !important;
    font-size: 12px !important;
}

.v-ripple__container {
    display: none !important;
}

.v-window__container {
    background: #181818;
}

.v-select__selection--comma {
    overflow: visible !important;
}

label {
    margin-bottom: 0px !important;
}

.colord-h1 {
    font-size: 28px;
    text-align: center;
    font-weight: 600;
}

.colord-h2 {
    font-size: 18px;
    text-align: center;
    font-weight: 500;
}

.colord-h3 {
    font-size: 16px;
    text-align: center;
    font-weight: 500;
}

.colord-h4 {
    font-size: 13px;
    text-align: center;
    font-weight: 600;
}

.colord-h5 {
    font-size: 12px;
    text-align: center;
    font-weight: 500;
}

.colord-button {
    font-weight: 600;
    font-size: 39;
}

.line-height-1-4 {
    line-height: 1.4;
}

.font-bold {
    font-weight: 600;
}

.font-normal {
    font-weight: normal;
}

.justify-content-between {
    justify-content: space-between;
}

.m-0 {
    margin: 0 !important;
}

.text-caps {
    text-transform: uppercase;
}

.d-grid {
    display: grid !important;
}

.switch,
.switch-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    > label {
        font-size: 11px;
        margin-bottom: 0;
        color: #989898;
        font-weight: normal;
        display: inline-block;
        vertical-align: middle;
        margin-right: 15px;
        line-height: 28px;
    }

    > input {
        width: 100%;
        height: 100%;
        margin: 0;
        opacity: 0;
        position: absolute;
        z-index: 10;
        cursor: pointer;
    }

    > .slider {
        position: relative;
        width: 30px;
        height: 16px;
        background-color: #ccc;
        transition: 0.4s;
        &:before {
            content: "";
            position: absolute;
            height: 12px;
            width: 12px;
            left: 2px;
            bottom: 2px;
            background-color: white;
            transition: 0.4s;
        }

        &.round {
            border-radius: 34px;
            &:before {
                border-radius: 50%;
            }
        }
    }

    > input:checked + .slider {
        background-color: #bb86fc;
        box-shadow: 0 0 1px #bb86fc;
        &:before {
            transform: translateX(15px);
        }
    }
}

.v-tooltip__content {
    padding: 5px 8px !important;
    // background: #212121 !important;
    line-height: 20px !important;
    font-size: 1rem !important;
    color: var(--font-default-color) !important;
}

.color-white {
    color: white !important;
}

.color-primary {
    color: var(--primary);
}

.color-warning {
    color: var(--color-warning);
}

.bg-primary {
    background-color: var(--primary) !important;
}

.bg-transparent {
    background-color: transparent !important;
}

.pointer-events-none {
    pointer-events: none;
}

.--overlay .block::after,
#filmstrip-container .thumbnail-container.--overlay::after {
    z-index: 10;
    content: '';
    display: block;
    background: rgba(0,0,0,.5 );
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.--overlay .file-name {
    color: rgba(255,255,255,.2 );
}

.btn-danger {
    background: var(--color-danger);
    span {
        color: white;
    }
}

#import-image-progress {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 50;
    width: 100%;
}

.v-btn {
    &.bg-primary {
        background-color: var(--primary) !important;
    }

    &.dashboard-button {
        border-radius: var(--box-rounding);
        padding: 7px 40px;
        color: white;
        text-transform: uppercase;
        font-size: 1rem;
        border: none;
        min-width: 125px;
        line-height: 20px;

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            &:hover {
                opacity: 0.5;
            }
        }
    }
}


.avatar {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    border: 1px solid var(--primary);
    background: white;
}

.color-warning {
    color: var(--color-warning);
    &:hover {
        color: var(--color-warning) !important;
    }
}

.color-accent-gradient {
    background: linear-gradient(to bottom, var(--color-accent) 0%, #f87fc3 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.password-tooltip {
    font-family: Poppins;
    border-radius: var(--box-rounding) !important;
    background-color: white !important;
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.1), 0 5px 8px 0 rgba(0, 0, 0, 0.1), 0 1px 14px 0 rgba(0, 0, 0, 0.08) !important;
}

div[data-tippy-root],
.tippy-popper {
    z-index: 10;
    pointer-events: initial;

    &[x-placement^="right"] {
        .tippy-tooltip {
            .tippy-arrow {
                border-right-color: #212121;
            }

            &.--start-theme {
                .tippy-arrow {
                    border-right-color: white;
                }
            }
        }
    }

	&[x-placement^="left"] {
		.tippy-tooltip {
			.tippy-arrow {
				border-left-color: #212121;
			}

			&.--start-theme {
				.tippy-arrow {
					border-left-color: white;
				}
			}
		}
	}

	&[x-placement="left-start"] {
		.tippy-arrow {
			top: 50% !important;
			transform: translateY(-50%);
		}
	}

    &[x-placement^="top"] {
        .tippy-tooltip {
            .tippy-arrow {
                border-top-color: #212121;
            }

            &.--start-theme {
                .tippy-arrow {
                    border-top-color: white;
                }
            }

            &.dashboard-theme {
                background: #121212;
                .tippy-arrow {
                    border-top-color: #121212;
                }
            }
        }
    }

    &[x-placement^="bottom"] {
        .tippy-arrow {
            border-bottom-color: #212121;
        }

        .tippy-tooltip.--start-theme {
            .tippy-arrow {
                border-bottom-color: white;
            }
        }
    }

    .tippy-tooltip,
	.tippy-box {
		padding: 10px 24px !important;
		background: #212121;

		.tippy-content,
		.tippy-content div {
			line-height: 18px;
			font-size: 1.2rem;
			color: var(--color-tooltip-text);
			font-weight: bold;
			font-family: Poppins;
			padding: 0;
		}

        .tippy-arrow {
            &:before {
                color: #212121;
            }
        }

        &.--start-theme {
            background: white;
            padding: 20px 25px !important;
            border-radius: var(--box-rounding);

            .tippy-content,
            .tippy-content div {
                line-height: 20px;
                font-size: 1rem;
                color: #444444;
                padding: 0;
            }

            .tippy-content div {
                display: flex;
                flex-direction: column;

                span,
                a {
                    text-align: left;
                }

                .step {
                    align-self: center;
                    margin-bottom: 20px;
                }

                .title {
                    font-weight: bold;
                    font-size: 13px;
                    margin-bottom: 15px;
                    text-align: center;
                }

                .description {
                    margin-bottom: 15px;
                    line-height: 1.3;
                }

                a {
                    margin-bottom: 15px;
                    font-weight: bold;
                    color: var(--primary);
                    text-decoration: none;
                }
            }

            .tippy-arrow {
                &:before {
                    color: white;
                }
            }
        }

        &.info-theme,
        &[data-theme~='info'] {
            padding: 25px !important;
            border-radius: var(--box-rounding);

            .tippy-content div {
                line-height: 20px;
                font-size: 1rem;
                text-align: left;
            }

            .tippy-content {
                line-height: 20px;
                font-size: 1rem;
                text-align: left;
            }
        }
    }
}

</style>
